import { useState } from 'react';
import { CONFIGURATION_KEYS } from '../../../../../helpers/constants';
import { getConfiguration } from '../../../../../helpers/utils';

const shouldShowAccuracyOverviewGraph = async () => {
    const { SHOW_ACCURACY_OVERVIEW_GRAPH } = CONFIGURATION_KEYS;
    const isAcuracyOverviewGraphVisible = await getConfiguration(
        SHOW_ACCURACY_OVERVIEW_GRAPH
    );

    return isAcuracyOverviewGraphVisible;
};

export const useIsGraphClickable = ({ averageAccuraciesHistory }) => {
    const [showAccuracyOverviewGraph, setShowAccuracyOverviewGraph] = useState(
        shouldShowAccuracyOverviewGraph(
            averageAccuraciesHistory
        ).then((response) => setShowAccuracyOverviewGraph(JSON.parse(response)))
    );

    return [showAccuracyOverviewGraph];
};



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/progress-display/use-show-accuracy-graph.js